module.exports = __webpack_public_path__ + "static/img/about_img.7ed14df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_img.png
// module id = W5AS
// module chunks = 52